import React from 'react'
import { Document, Page, Text, View, Image, StyleSheet } from '@react-pdf/renderer';

const pdfBG = "https://res.cloudinary.com/dgfe2cxwn/image/upload/v1676924681/seeraht-school/admission-form-seeraht-school_cuwjqb.png"

export default function PDF({ data }) {
    const { campus = {}, fullName, cnic, gender, dob, age, registrationNumber, bloodGroup, religion, province, city, address, fatherName, fatherCNIC, motherName, motherCNIC, phone, whatsapp, email, emergencyContact, photoURL } = data
    return (
        <Document
            title={`CoDev Admission Form for ${fullName}`}
            author={window.appName}
            subject={`CoDev Admission Form for ${fullName}`}
        >
            <Page size="A4" style={styles.page}>
                <View style={styles.pdfBG}><Image source={{ uri: pdfBG }}></Image></View>
                <Image source={photoURL} style={styles.photo} />
                <Text style={[styles.textSmall, { position: "absolute", top: 84, left: 112 }]}>+{campus.phone}</Text>
                <Text style={[styles.textSmall, { position: "absolute", top: 102, left: 112 }]}>{campus.address}</Text>

                <View style={styles.content}>
                    <Text style={styles.textSmall}>{fullName}</Text>
                    <View style={styles.row}>
                        <View style={styles.col}>
                            <Text style={styles.textSmall}>{cnic}</Text>
                        </View>
                        <View style={[styles.col, styles.col2]}>
                            <Text style={styles.textSmallCapitalize}>{gender}</Text>
                        </View>
                    </View>
                    <View style={styles.row}>
                        <View style={styles.col}>
                            <Text style={styles.textSmall}>{window.dateFormat(dob, "MMMM DD YYYY")}</Text>
                        </View>
                        <View style={[styles.col, styles.col2]}>
                            <Text style={styles.textSmall}>{age}</Text>
                        </View>
                    </View>
                    <View style={styles.row}>
                        <View style={styles.col}>
                            <Text style={styles.textSmall}>{campus.name}</Text>
                        </View>
                        <View style={[styles.col, styles.col2]}>
                            <Text style={styles.textSmall}>{"section?.label"}</Text>
                        </View>
                    </View>
                    <View style={styles.row}>
                        <View style={styles.col}>
                            <Text style={styles.textSmall}>{"klass?.label"}</Text>
                        </View>
                        <View style={[styles.col, styles.col2]}>
                            <Text style={styles.textSmall}>{registrationNumber}</Text>
                        </View>
                    </View>
                    <View style={styles.row}>
                        <View style={styles.col}>
                            <Text style={[styles.textSmallCapitalize]}>{bloodGroup}</Text>
                        </View>
                        <View style={[styles.col, styles.col2]}>
                            <Text style={[styles.textSmallCapitalize]}>{religion}</Text>
                        </View>
                    </View>
                    <View style={styles.row}>
                        <View style={styles.col}>
                            <Text style={styles.textSmall}>{province.name}</Text>
                        </View>
                        <View style={[styles.col, styles.col2]}>
                            <Text style={styles.textSmall}>{city.name}</Text>
                        </View>
                    </View>
                    <View style={styles.row}>
                        <Text style={styles.textSmall}>{address}</Text>
                    </View>
                </View>
                <View style={[styles.content, { marginTop: 55 }]}>
                    <View style={styles.row}>
                        <View style={styles.col}>
                            <Text style={styles.textSmall}>{fatherName}</Text>
                        </View>
                        <View style={[styles.col, styles.col2]}>
                            <Text style={styles.textSmall}>{fatherCNIC}</Text>
                        </View>
                    </View>
                    <View style={styles.row}>
                        <View style={styles.col}>
                            <Text style={styles.textSmall}>{motherName}</Text>
                        </View>
                        <View style={[styles.col, styles.col2]}>
                            <Text style={styles.textSmall}>{motherCNIC}</Text>
                        </View>
                    </View>
                </View>
                <View style={[styles.content, { marginTop: 55 }]}>
                    <View style={styles.row}>
                        <View style={styles.col}>
                            <Text style={styles.textSmall}>{phone}</Text>
                        </View>
                        <View style={[styles.col, styles.col2]}>
                            <Text style={styles.textSmall}>{whatsapp}</Text>
                        </View>
                    </View>
                    <View style={styles.row}>
                        <Text style={styles.textSmall}>{email}</Text>
                    </View>
                </View>
                <View style={[styles.content, { marginTop: 55 }]}>
                    <View style={styles.row}>
                        <View style={styles.col}>
                            <Text style={styles.textSmallCapitalize}>{emergencyContact.relation}</Text>
                        </View>
                        <View style={[styles.col, styles.col2]}>
                            <Text style={styles.textSmall}>{emergencyContact.fullName}</Text>
                        </View>
                    </View>
                    <View style={styles.row}>
                        <View style={styles.col}>
                            <Text style={[styles.textSmall]}>{emergencyContact.phone}</Text>
                        </View>
                        <View style={[styles.col, styles.col2]}>
                            <Text style={[styles.textSmall]}>{emergencyContact.phone2}</Text>
                        </View>
                    </View>
                </View>

            </Page>
        </Document>
    )
}

const styles = StyleSheet.create({
    page: {
        backgroundColor: 'white',
        flexDirection: "column"
    },
    pdfBG: {
        position: "absolute",
        top: 0,
        width: "100%"
    },
    photo: {
        width: 93,
        height: 91,
        position: "absolute",
        top: 38,
        right: 35,
    },
    textSmall: {
        fontSize: 12
    },
    textSmallCapitalize: {
        fontSize: 12,
        textTransform: "capitalize"
    },
    content: {
        width: 420,
        top: 245,
        left: 138,
    },
    row: {
        marginTop: 12,
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between"
    },
    col: {
        width: 162,
    },
    col2: {
        width: 152,
    },
});